<template>
    <div class="animated fadeIn">
        <b-row class="justify-content-center">
            <b-col xl="6" lg="8">
                <b-card>
                    <div slot="header">
                        Closing Current Periode (bulan berjalan pembukuan)
                    </div>
                        <b-row>
                            <b-col cols="8">
                                <b-input-group >
                                    <b-input-group-prepend><label>Current Periode</label></b-input-group-prepend>
                                    <b-form-input v-model="model.monthaktif" readonly></b-form-input>                                        
                                </b-input-group>
                            </b-col>
                            <b-col cols="4">    
                                <b-input-group >
                                    <b-input-group-prepend><label>Current Periode No</label></b-input-group-prepend>
                                    <b-form-input v-model="model.periodaktif" readonly></b-form-input>                                        
                                </b-input-group>
                            </b-col>
                        </b-row>                      
                        <b-row>
                            <b-col cols="8">
                                <b-input-group >
                                    <b-input-group-prepend><label>Next Periode Name</label></b-input-group-prepend>
                                    <b-form-input v-model="model.monthnext" readonly></b-form-input>                                        
                                </b-input-group>
                            </b-col>
                            <b-col cols="4">    
                                <b-input-group >
                                    <b-input-group-prepend><label>Next Periode No.</label></b-input-group-prepend>
                                    <b-form-input v-model="model.periodnext" readonly></b-form-input>                                        
                                </b-input-group>
                            </b-col>
                        </b-row>    
                        <b-row class="justify-content-center mt-2">
                            <button  class="btn btn-primary mr-1" @click="closePeriode()"><i class="fa fa-save"></i> Close Current Periode</button>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close </button>
                        </b-row>
                </b-card>
            </b-col>
        </b-row>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import periode from "../../apis/consolperiode";
toastr.init();

export default {
  components: {Loading},
  data() {
    return {
      horizontal: true,
      isLoading:false,
      model:{tglnext:'', periodnext:'-'},
    };
  },    
  created: async function (){
    //  const { user } = this.$store.state;
     const curPeriode = await periode.get();
     var tglaktifconsol=moment(curPeriode.tglaktifconsol,'YYYY-MM-DD');
     var tglnext=moment(curPeriode.tglaktifconsol,'YYYY-MM-DD').add(1,'M');
     this.model.monthaktif=tglaktifconsol.format('MMMM YYYY');
     this.model.monthnext=tglnext.format('MMMM YYYY');
     this.model.tglaktifconsol=curPeriode.tglaktifconsol;
     this.model.tglnext=tglnext.format('YYYY-MM-DD');
     this.model.awalbln=curPeriode.awalbln;
    if (tglaktifconsol.get('month') < (this.model.awalbln - 1)){
        this.model.periodaktif = tglaktifconsol.get('month') + 11;
    } else {
        this.model.periodaktif = tglaktifconsol.get('month') + 2 - this.model.awalbln;
    }
    if (tglnext.get('month') < (this.model.awalbln - 1)) {
        this.model.periodnext = tglnext.get('month') + 11;
    } else {
        this.model.periodnext = tglnext.get('month') + 2 - this.model.awalbln;
    }
    this.$forceUpdate();

  },  
  methods: {
    async closePeriode(){
        this.isLoading=true;
        try {
            let user = await periode.closing(this.model);
            this.isLoading=false;    
            toastr.success("Complete successfully", "Closing Periode");
            // console.log(user);
            this.$store.commit("user",user);
            var tglaktifconsol=moment(user.tglaktifconsol,'YYYY-MM-DD');
            var tglnext=moment(user.tglaktifconsol,'YYYY-MM-DD').add(1,'M');
            this.model.monthaktif=tglaktifconsol.format('MMMM YYYY');
            this.model.monthnext=tglnext.format('MMMM YYYY');
            this.model.tglaktifconsol=tglaktifconsol.format('YYYY-MM-DD');
            this.model.tglnext=tglnext.format('YYYY-MM-DD');
            if (tglaktifconsol.get('month') < (this.model.awalbln - 1)){
                this.model.periodaktif = tglaktifconsol.get('month') + 11;
            } else {
                this.model.periodaktif = tglaktifconsol.get('month') + 2 - this.model.awalbln;
            }
            if (tglnext.get('month') < (this.model.awalbln - 1)) {
                this.model.periodnext = tglnext.get('month') + 11;
            } else {
                this.model.periodnext = tglnext.get('month') + 2 - this.model.awalbln;
            }
            toastr.info("Current Periode has been Change ");
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    }, 
    close(){
      router.push("home");
    }, 
  }
};
</script>